export class UnidadTerminada {
    public idUnidadTerminada: number;
    public idOrdenServicio: number;
    public observaciones: string;
    public idEmpleado: number;
    public status: string;
    public fechaAceptacion: Date;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/unidadTerminada.ts